import { isBreakingSpace } from '../textMetricsHelpers';
import { TextMetricList } from './TextMetricList';
import type { WordElementMetrics } from './WordElementMetrics';

export class HighlightSpanMetrics extends TextMetricList<WordElementMetrics> {
    override _getSourceWordReferenceIndices(): never[] {
        // could support if needed, just have to de-duplicate the indices from the word elements but don't need this right now
        throw new Error(
            'CanvasHighlightSpanMetrics does not support getSourceWordReferenceIndices',
        );
    }

    get elements(): WordElementMetrics[] {
        return this.children;
    }

    get visibleWords(): WordElementMetrics[] {
        return this.children.filter((child) => !isBreakingSpace(child.text));
    }
}
